module.exports = __webpack_public_path__ + "img/background011.0c4fc1e3.jpg";